import React, { FC } from "react";
import AppUICard from "../cards/AppUICard";
import ArtistCard from "../cards/ArtistCard";
// import AlbumCard from "../cards/AlbumCard";
import MultiCard from "../cards/MultiCard";
import { connect } from "react-redux";
import { RootState } from "../../store/reducers";
import { Playlist } from "../../models/playlist";
import { Track } from "../../models/track";
import { User } from "../../models/user";
// import PlaylistItem from "./subs/PlaylistItem";

const Discover: FC<{
  list: Track[];
  users: User[];
  playlists: Playlist[];
  // tags?: string[]
}> = ({ list, playlists, users }) => {
  document.getElementsByTagName("title")[0].innerHTML = "discover";

  return (
    <div className="app-view">
      <div className="app-view-body" id="discover">
        {/* <div className="discover-item">
          <h4>Tags</h4>
          <div className=" uk-text-center genres">
            {tags &&
              tags.map((tag, i) => (
                <div key={i} className="genre">
                  <div
                    style={{ background: randomColor() }}
                    className="uk-card g-card uk-padding-small uk-border-rounded"
                  >
                    {tag}
                  </div>
                </div>
              ))}
          </div>
        </div> */}

        <div className="discover-item">
          <h4 className="app-text">Artists</h4>
          <div id="discover-artists">
            {users &&
              users.map((user) => <ArtistCard user={user} key={user.id} />)}
          </div>
        </div>
        <div className="discover-item">
          <h4 className="app-text">Popular Tracks</h4>
          <div className="tracks-grid">
            {list &&
              list
                .sort((a, b) =>
                  a.plays.length > b.plays.length &&
                  a.likes.length > b.likes.length
                    ? -1
                    : 1
                )
                .map((track) => <AppUICard track={track} key={track.id} />)}
          </div>
        </div>

        <div className="featured-item">
          <h4 className="app-text">Popular Albums</h4>
          <div id="playlist-render">
            {playlists &&
              playlists.map((playlist, i) => {
                return <MultiCard key={i} playlist={playlist} />;
              })}
          </div>
        </div>

        <div className="featured-item">
          <h4 className="app-text">Popular Playlists</h4>
          <div id="playlist-render">
            {playlists &&
              playlists.map((playlist, i) => (
                <MultiCard key={i} playlist={playlist} />
              ))}
          </div>
        </div>
      </div>
      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {users &&
                users.map((user) => <ArtistCard user={user} key={user.id} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  list: state.data.list,
  playlists: state.data.playlists,
  users: state.data.users,
  // tags: state.songs.tags,
});

export default connect(mapStateToProps)(Discover);
